import { useCallback, useMemo } from "react";
import { PARTNER_TYPES_QUERY } from "features/insuranceDocument/edit/general/partner/queries";
import { useDictionaryHandling, useParams } from "hooks";

export function usePartnerType() {
  const { dictionary: partnerTypesData } = useDictionaryHandling(PARTNER_TYPES_QUERY, "partnerTypes");

  const individualPartnerType = useParams("IndividualPartnerType");
  const companyPartnerType = useParams("CompanyPartnerType");
  const individualCompanyPartnerType = useParams("IndividualCompanyPartnerType");

  const individualPartnerTypeId = useMemo(() => {
    return partnerTypesData.find(x => x.code === individualPartnerType)?.id;
  }, [partnerTypesData, individualPartnerType]);

  const companyPartnerTypeId = useMemo(() => {
    return partnerTypesData.find(x => x.code === companyPartnerType)?.id;
  }, [partnerTypesData, companyPartnerType]);

  const individualCompanyPartnerTypeId = useMemo(() => {
    return partnerTypesData.find(x => x.code === individualCompanyPartnerType)?.id;
  }, [partnerTypesData, individualCompanyPartnerType]);

  const isPF = useCallback(
    partnerTypeId => {
      if (!individualPartnerTypeId) return false;
      return partnerTypeId === individualPartnerTypeId;
    },
    [individualPartnerTypeId]
  );

  const isPJ = useCallback(
    partnerTypeId => {
      if (!companyPartnerTypeId) return false;
      return partnerTypeId === companyPartnerTypeId;
    },
    [companyPartnerTypeId]
  );

  const isPFA = useCallback(
    partnerTypeId => {
      if (!individualCompanyPartnerTypeId) return false;
      return partnerTypeId === individualCompanyPartnerTypeId;
    },
    [individualCompanyPartnerTypeId]
  );

  return { isPF, isPFA, isPJ };
}

export default usePartnerType;
